import React from "react"
import { FaCheck } from "react-icons/fa"

const ButtonView: React.FC<{ title: string; onClick: () => void }> = ({
  title,
  onClick,
}) => (
  <button
    type="button"
    className="text-center px-6 py-2 rounded inline-flex items-center
                  bg-blue-100 text-blue-800 hover:text-blue-100 hover:bg-blue-700
                  hover:shadow"
    onClick={onClick}
  >
    {title}
  </button>
)

const SelectedButtonView: React.FC<{ title: string }> = ({ title }) => (
  <button
    type="button"
    className="text-center px-6 py-2 rounded inline-flex items-center
                  bg-blue-700 text-blue-100 hover:text-blue-100 hover:bg-blue-800
                  hover:shadow"
  >
    <span
      className="mr-3 leading-none"
      style={{ height: "20px", width: "20px" }}
    >
      <FaCheck />
    </span>
    <span>{title}</span>
  </button>
)

const SelectButton: React.FC<{
  onClick: (title: string, value: any) => void
  title: string
  value: any
  selected: boolean
}> = ({ onClick, title, value, selected }) => {
  if (selected)
    return (
      <div className="mb-2 mr-2">
        <SelectedButtonView title={title} />
      </div>
    )

  return (
    <div className="mb-2 mr-2">
      <ButtonView title={title} onClick={() => onClick(title, value)} />
    </div>
  )
}

export default SelectButton
